import { useEffect } from 'react';
import chatttSDK from 'services/chattt';
import useShopeeAuthShops from './useShopeeAuthShops';

const useShopeeImageCaptcha = () => {
  const { taskId, authCaptchaState, continueImageCaptcha } = useShopeeAuthShops();
  useEffect(() => {
    let timer = -1;
    if (
      chatttSDK?.shopee?.multiAuth &&
      taskId &&
      authCaptchaState.authAgent &&
      authCaptchaState.authAgent.status === 'WaitForImageCaptcha'
    ) {
      timer = window.setTimeout(() => {
        continueImageCaptcha();
      }, 3000);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [taskId, authCaptchaState.authAgent, continueImageCaptcha]);
};

export default useShopeeImageCaptcha;
